import { messages } from '@qality/common-messages';
import { FlagService } from '@qality/common-service';

import URLService from './URLService';

export default {
  createLinkErrorFlag(testCase) {
    const link = URLService.getBrowseIssueUrl(testCase.key);
    const body =
      messages['error.qalityIssueView.createLinkTestCase.body'] +
      '<br/><a class="aui-button aui-button-link" href="' +
      link +
      '">' +
      testCase.key +
      '</a>';

    FlagService.createControlledFlag(
      messages['error.qalityIssueView.createLinkTestCase.header'],
      body,
      'error',
      15000
    );
  },

  async showCreateIssueDialog(name, issueTypeId, projectId) {
    return new Promise((resolve) => {
      showCreateIssueForm(issueTypeId, projectId, resolve);
    });
  },

  async showCreateIssueDialogWithDescription(
    name,
    issueTypeId,
    projectId,
    description
  ) {
    return new Promise((resolve) => {
      showCreateIssueForm(issueTypeId, projectId, resolve);

      let setDescription;
      window.JIRA.bind(
        'dialogContentReady',
        (setDescription = () => {
          window.AJS.$('#description').val(description);
          window.JIRA.unbind('dialogContentReady', setDescription);
        })
      );
    });
  },
};

function showCreateIssueForm(issueTypeId, projectId, resolve) {
  const issueForm = window.JIRA.Forms.createCreateIssueForm({
    pid: projectId,
    issueType: issueTypeId,
  });

  issueForm.bind('sessionComplete', function (_ev, issues) {
    try {
      const createdIssues = issues.map((issue) => {
        return issue.createdIssueDetails;
      });

      window.AJS.$('#description').val('');
      window.JIRA.unbind('Dialog.hide', hideFunction);

      resolve(createdIssues);
    } catch (e) {
      resolve([]);
    }
  });

  let hideFunction;
  window.JIRA.bind(
    'Dialog.hide',
    (hideFunction = function () {
      window.JIRA.unbind('Dialog.hide', hideFunction);
      window.AJS.$('#description').text('');

      resolve([]);
    })
  );

  issueForm.asDialog().show();
  return issueForm;
}
